const state = {
    user: {
        id: null,
        name: null,
        email: null,
        role: null,
        role_tfg: null,
        permissions: [],
        token: null
    },
    userTemp: {
        id: null,
        name: null,
        email: null,
        role: null,
        role_tfg: null,
        permissions: [],
        token: null
    },
    isAuthenticated: false,
};

const mutations = {
    SET_USER_ROLE(state, role) {
        state.user.role = role;
    },
    SET_USER_PERMISSIONS(state, permissions) {
        state.user.permissions = permissions;
    },
    SET_USER_DATA(state, userData) {
        state.user = { ...state.user, ...userData };
        state.isAuthenticated = true;
    },
    UPDATE_USER_TOKEN(state, token) {
        state.user.token = token;
    },
    SET_USER_DATA_TEMP(state, userData) {
        state.userTemp = { ...state.userTemp, ...userData };
    },
    SET_AUTHENTICATED(state, value) {
        state.isAuthenticated = value;
    },
    CLEAR_USER_DATA(state) {
        state.user = {
            id: null,
            name: null,
            email: null,
            role: null,
            role_tfg: null,
            permissions: []
        };
        
        state.isAuthenticated = false; 
    },
    CLEAR_USER_DATA_TEMP(state) {
        state.userTemp = {
            id: null,
            name: null,
            email: null,
            role: null,
            role_tfg: null,
            permissions: []
        };
    }
};

const actions = {
    setUserRole({ commit }, role) {
        commit('SET_USER_ROLE', role);
    },
    setUserPermissions({ commit }, permissions) {
        commit('SET_USER_PERMISSIONS', permissions);
    },
    setUserData({ commit }, userData) {
        commit('SET_USER_DATA', userData);
    },
    updateUserToken({ commit }, token) {
        commit('UPDATE_USER_TOKEN', token);
    },
    setUserDataTemp({ commit }, userData) {
        commit('SET_USER_DATA_TEMP', userData);
    },
    setAuthenticated({ commit }, value) {
        commit('SET_AUTHENTICATED', value);
    },
    clearUserData({ commit }) {
        commit('CLEAR_USER_DATA');
    },
    clearUserDataTemp({ commit }) {
        commit('CLEAR_USER_DATA_TEMP');
    }
};

const getters = {
    isAdmin: state => state.user.role === 1,
    hasPermission: state => permission => {
        return state.user.permissions.includes(permission);
    },
    userRole: state => state.user.role,
    userData: state => state.user,
    userDataTemp: state => state.userTemp,
    isAuthenticated: state => state.isAuthenticated,
    canSwitchProfiles: state => state.user.role === 1
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}; 